import { render, staticRenderFns } from "./LivingDonorLabsSection.vue?vue&type=template&id=795ef113"
import script from "./LivingDonorLabsSection.vue?vue&type=script&lang=ts"
export * from "./LivingDonorLabsSection.vue?vue&type=script&lang=ts"
import style0 from "./LivingDonorLabsSection.vue?vue&type=style&index=0&id=795ef113&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports